export default __webpack_public_path__ + "static/media/snr.089381c7.mp3";